import { addSubdomain } from '~/utils/urlSubdomainUtils'

/**
 * Minimal composable for adding the current subdomain to URLs
 */
export const useAddCurrentSubdomain = () => {
  const subdomain = useSubdomain()

  /**
   * Add the current subdomain to a URL
   * @param url - The URL to modify
   * @returns The URL with the current subdomain added
   */
  const addCurrentSubdomain = (url: string): string => {
    return addSubdomain(url, subdomain.value || null)
  }

  return addCurrentSubdomain
}
